var _a;
const DAWN_CART_TAGS = ["cart-drawer", "cart-items", "cart-drawer-items", "cart-notification"];
const DAWN_PUBSUB_REFRESHED_SECTIONS = /* @__PURE__ */ new Set([
  "cart-drawer:cart-drawer",
  "cart-drawer-items:CartDrawer",
  "cart-items:main-cart-items"
]);
function collectCartSections() {
  var _a2, _b, _c;
  const sections = /* @__PURE__ */ new Map();
  for (const el of document.querySelectorAll(DAWN_CART_TAGS.join(","))) {
    let entries;
    try {
      entries = (_a2 = el.getSectionsToRender) == null ? void 0 : _a2.call(el);
    } catch (e) {
      continue;
    }
    const tag = el.tagName.toLowerCase();
    for (const entry of entries != null ? entries : []) {
      if (DAWN_PUBSUB_REFRESHED_SECTIONS.has(`${tag}:${entry.id}`)) continue;
      const sectionId = (_b = entry.section) != null ? _b : entry.id;
      if (!sectionId || sections.has(sectionId)) continue;
      const root = entry.section ? document.getElementById(entry.id) : document;
      if (!root) continue;
      const mount = entry.selector ? (_c = root.querySelector(entry.selector)) != null ? _c : entry.section ? root : null : document.getElementById(entry.id);
      if (!mount) continue;
      sections.set(sectionId, {
        mount,
        extractSelector: entry.selector || ".shopify-section"
      });
    }
  }
  return sections;
}
async function refreshDawnCartUI() {
  const sections = collectCartSections();
  const sectionsQuery = sections.size ? `?sections=${[...sections.keys()].join(",")}` : "";
  const cartUrl = typeof routes !== "undefined" && (routes == null ? void 0 : routes.cart_url) || "/cart";
  const url = `${cartUrl}.js${sectionsQuery}`;
  const cartData = await fetch(url, { headers: { Accept: "application/json" } }).then((r) => r.ok ? r.json() : null).catch(() => null);
  if (cartData == null ? void 0 : cartData.sections) {
    for (const [id, { mount, extractSelector }] of sections) {
      const html = cartData.sections[id];
      if (!html) continue;
      const source = new DOMParser().parseFromString(html, "text/html").querySelector(extractSelector);
      if (source) mount.replaceChildren(...source.childNodes);
    }
  }
  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: "external-refresh",
    cartData: cartData != null ? cartData : void 0
  });
}
function initStandardActions() {
  var _a2;
  const actions = (_a2 = window.Shopify) == null ? void 0 : _a2.actions;
  if (!actions) return;
  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.open === "function") {
        drawer.open();
        return;
      }
      return defaultHandler();
    }
  });
  actions.updateCart.configure({
    // Dawn doesn't currently listen for shopify:cart:* events, but the
    // bundle requires an eventTarget. document is the conventional root.
    eventTarget: () => document,
    async handler(defaultHandler) {
      if (window.__dawnCartAjaxMutationCount > 0) return;
      const result = await defaultHandler();
      try {
        await refreshDawnCartUI();
      } catch (error) {
        console.error("[Dawn] Standard Actions cart refresh failed; reloading.", error);
        window.location.reload();
      }
      return result;
    }
  });
}
if ((_a = window.Shopify) == null ? void 0 : _a.actions) {
  initStandardActions();
} else {
  document.addEventListener("DOMContentLoaded", initStandardActions, { once: true });
}
